import React from 'react';
import { MessageStatus } from '../../MessageStatus';

interface MessageBlockProps {
  rejectReason?: string | null;
  isAuthor: boolean;
  isPublished: boolean;
  isExpired: boolean;
  isLimited: boolean;
  isRejected: boolean;
  isPending: boolean;
  isExpiredManually: boolean;
  isLeased: boolean;
  expiresAt: string;
}

export const MessageBlock: React.FC<MessageBlockProps> = ({
  rejectReason,
  isAuthor,
  isPublished,
  isExpired,
  isLimited,
  isRejected,
  isPending,
  isExpiredManually,
  isLeased,
  expiresAt
}) => {
  return (
    <>
      {isAuthor && !isPublished && (
        <MessageStatus
          {...{
            rejectReason,
            isExpired,
            isLimited,
            isRejected,
            isPending,
            expiresAt,
            isLeased,
            isExpiredManually
          }}
        />
      )}
      {!isAuthor && isExpired && (
        <MessageStatus
          expiresAt={isExpiredManually ? expiresAt : ''}
          {...{ rejectReason, isExpired, isExpiredManually, isLeased }}
        />
      )}
    </>
  );
};
